import { render, staticRenderFns } from "./PerformancePersonList.vue?vue&type=template&id=2029bda0&scoped=true&"
import script from "./PerformancePersonList.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029bda0",
  null
  
)

export default component.exports